import React, { useEffect, useState } from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import { BiSolidEdit } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { createCommentForPartner, deleteComment, updateComment, getCommentsForPartner } from "../redux/apiCalls/accidentApiCall";

function AdminNotizenPartner() {
  const dispatch = useDispatch();
  const { partner } = useSelector(state => state.accident);
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [editableNoteId, setEditableNoteId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // جلب البيانات عند تحميل الصفحة
  useEffect(() => {
    console.log("Rendering AdminNotizenPartner component");
    if (partner?.user?._id) {
      console.log("Dispatching getCommentsForPartner with partner user ID: ", partner.user._id);
      dispatch(getCommentsForPartner(partner.user._id));
    } else {
      console.log("No partner user ID found");
    }
  }, [dispatch, partner?.user?._id]);

  // دالة لإضافة أو تحديث ملاحظة
  const handleAddOrUpdateComment = async () => {
    console.log("handleAddOrUpdateComment triggered");
    if (!text.trim() || !title.trim()) {
      console.log("Title or text is empty");
      alert("Both title and comment are required!");
      return;
    }

    if (editableNoteId) {
      console.log("Updating comment with ID: ", editableNoteId);
      await dispatch(updateComment(editableNoteId, text, title, "partner"));
    } else {
      console.log("Creating a new comment for partner");
      await dispatch(createCommentForPartner(text, partner.user._id, title));
    }

    // إعادة جلب البيانات بعد التعديل
    console.log("Dispatching getCommentsForPartner after comment update/addition");
    dispatch(getCommentsForPartner(partner.user._id));
    resetModal();
  };

  // دالة لمسح القيم بعد الإضافة أو التعديل
  const resetModal = () => {
    console.log("Resetting modal state");
    setText("");
    setTitle("");
    setEditableNoteId(null);
    setIsModalOpen(false);
  };

  // دالة لتحويل التاريخ إلى الصيغة المطلوبة
  const renderDate = (dateString) => {
    console.log("Rendering date for: ", dateString);
    const date = new Date(dateString);
    return `${date.getUTCDate().toString().padStart(2, '0')}.${(date.getUTCMonth() + 1).toString().padStart(2, '0')}.${date.getUTCFullYear()}`;
  };

  return (
    <div className="overflow-x-auto">
      {/* تحقق من وجود بيانات الملاحظات */}
      {partner?.user?.notes?.length > 0 ? (
        <table className="min-w-full border border-gray-300 rounded-lg shadow-lg">
          <thead className="bg-gradient-to-r from-black to-[#DAA520] text-white">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-bold border-b border-gray-400">Betreff</th>
              <th className="px-6 py-3 text-left text-sm font-bold border-b border-gray-400">Datum</th>
              <th className="px-6 py-3 text-center text-sm font-bold border-b border-gray-400">Aktion</th>
            </tr>
          </thead>
          <tbody>
            {partner.user.notes.map((row, index) => (
              <tr key={row._id} className={`${index % 2 === 0 ? "bg-white" : "bg-gray-100"} hover:bg-gray-200 transition-all`}>
                <td className="px-6 py-2 text-sm font-bold border-b border-gray-300">{row.title}</td>
                <td className="px-6 py-2 text-sm font-bold border-b border-gray-300">{renderDate(row.createdAt)}</td>
                <td className="px-6 py-2 text-center border-b border-gray-300">
                  <button
                    onClick={() => {
                      console.log("Deleting comment with ID: ", row._id);
                      dispatch(deleteComment(row._id, "partner")).then(() => {
                        dispatch(getCommentsForPartner(partner.user._id));
                      });
                    }}
                    className="text-red-500 hover:text-red-700 mx-2"
                  >
                    <RiDeleteBin6Line className="text-2xl" />
                  </button>
                  <button onClick={() => {
                    console.log("Editing comment with ID: ", row._id);
                    setText(row.text);
                    setTitle(row.title);
                    setEditableNoteId(row._id);
                    setIsModalOpen(true);
                  }} className="text-blue-500 hover:text-blue-700">
                    <BiSolidEdit className="text-2xl" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-center font-bold mt-4">There are no notes</div>
      )}

      {/* زر لإضافة ملاحظة جديدة */}
      <div className="flex justify-center items-center mt-6">
        <button onClick={() => setIsModalOpen(true)} className="bg-[#DAA520] hover:bg-[#b8911a] text-black font-semibold py-2 px-4 border border-black rounded shadow-md">
          + Neue Notiz
        </button>
      </div>

      {/* نافذة المودال */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-bold mb-4 text-center">Schreiben Sie bitte hier Ihre Notizen</h2>
            <div className="flex flex-col mb-4">
              <label className="font-medium">Titel:</label>
              <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} className="bg-gray-200 px-4 py-2 rounded focus:outline-none" />
            </div>
            <div className="flex flex-col mb-4">
              <label className="font-medium">Text:</label>
              <textarea value={text} onChange={(e) => setText(e.target.value)} className="bg-gray-200 px-4 py-2 rounded h-24 focus:outline-none resize-none"></textarea>
            </div>
            <div className="flex justify-center mt-4">
              <button onClick={handleAddOrUpdateComment} className="bg-[#DAA520] hover:bg-[#b8911a] text-black font-semibold py-2 px-4 border border-black rounded shadow-md">
                {editableNoteId ? "Aktualisieren" : "Hinzufügen"}
              </button>
              <button onClick={resetModal} className="ml-4 bg-gray-500 hover:bg-gray-700 text-white font-semibold py-2 px-4 rounded shadow-md">
                Schließen
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminNotizenPartner;
